export default __webpack_public_path__ + "static/media/Xhighlight Logo White X 2.a79e286b.png";